import { H4 } from "../typography/H4";

export const PartnerNotificationHeader = () => {
  return (
    <H4 className="text-semantic-text-heading mt-[22px] mb-[34px] w-full">
      공지사항
    </H4>
  );
};
